import http from '@/utils/http';
import store from '../store';
import i18n from '@/main';

export default {
    buscarDadosUsuarioLogado(lockScreen = true) {
        return http
            .get({
                url: '/auth/logged',
                lockScreen: lockScreen,
                lockMessage: i18n.t('mensagens.sistema.buscandoDadosDoUsuario')
            })
            .catch(() => {
                store.dispatch('setUsuarioLogado', null);
            });
    },
    isLogged() {
        return http
            .get({
                url: '/auth/logged',
                lockScreen: false,
                lockMessage: i18n.t('mensagens.sistema.buscandoDadosDoUsuario')
            })
            .catch(() => {
                store.dispatch('setUsuarioLogado', null);
            });
    },
    setSessionLocale() {
        return http.get({
            url: '/locale',
            lockScreen: false
        });
    }
};
